module.exports = __webpack_public_path__ + "img/pay-success.78f42d27.png";